import { fromJS } from 'immutable';

import { loginRoutine, fetchUserRoutine, resetPasswordRoutine } from '../routines';

const initialState = fromJS({
});

export default function (state = initialState, action) {
  switch (action.type) {
    case loginRoutine.SUCCESS:
    case fetchUserRoutine.SUCCESS:
      return state.set('user', fromJS(action.payload.user));
    case resetPasswordRoutine.TRIGGER:
      // return state.setIn('resetPassword')
      return state;
    case resetPasswordRoutine.SUCCESS:
      return state.set('message', 'Password reset email was sent. Please check your email.');
    case resetPasswordRoutine.FAILURE:
      return state.set('error', action.error);
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/authentication.js